import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import './workStyles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import heartIcon from '../../img/heart-icon.svg';
import governmentIcon from '../../img/government-icon.svg';
import commercialIcon from '../../img/commercial-icon.svg';


function OurWorkServe() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
        <Container className={"workServeStyle"} maxWidth={false} component="section">
            <Container className={"workServeStyleInner"} maxWidth={false} component="section">
                <Grid className={globalClasses.containerSmall} container >
                    <Grid className={globalClasses.containerVertPadding} container>
                    <Grid item xs={12} md={12}  >
                        <Typography  align="center" variant="subtitle1">Who We Serve</Typography>
                        <Typography  align="center" variant="h2">It all begins with collaboration</Typography>
                        <Typography  align="center" variant="body1">We feel a profound sense of pride in the work of our clients, and it is our privilege to play a role in your mission and goals. When you apply innovative thinking and technological know-how to purposeful work, the result is striking. </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <img className={globalClasses.imgStyle} src={heartIcon} alt="nonprofit icon" />
                        <Typography  align="center" variant="h5">Non-Profit and Associations</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <img className={globalClasses.imgStyle} src={governmentIcon} alt="government icon"/>
                        <Typography  align="center" variant="h5">Government</Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <img className={globalClasses.imgStyle} src={commercialIcon} alt="commercial icon"/>
                        <Typography  align="center" variant="h5">Commercial</Typography>
                    </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    </ThemeProvider>
  );
};

export default OurWorkServe;